import { render, staticRenderFns } from "./comprehensiveSorce.vue?vue&type=template&id=c4b456dc&scoped=true&"
import script from "./comprehensiveSorce.vue?vue&type=script&lang=js&"
export * from "./comprehensiveSorce.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveSorce.vue?vue&type=style&index=0&id=c4b456dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b456dc",
  null
  
)

export default component.exports